window.notificationsPanelData = function () {
    return {
        activeTab: 'team',
        tabs: {
            team: { items: [], page: 0, hasMore: true, loading: false, loaded: false },
            user: { items: [], page: 0, hasMore: true, loading: false, loaded: false },
            site: { items: [], page: 0, hasMore: true, loading: false, loaded: false }
        },
        unreadCounts: { user: 0, team: 0, site: 0 },

        init() {
            let self = this;
            window.addEventListener('sidebar-counts-updated', function (e) {
                self.unreadCounts.user = e.detail.user;
                self.unreadCounts.team = e.detail.team;
                self.unreadCounts.site = e.detail.site;
            });

            window.addEventListener('notifications-panel-opened', function () {
                self.onPanelOpened();
            });
        },

        onPanelOpened() {
            if (!this.tabs[this.activeTab].loaded) {
                this.fetchPage(this.activeTab);
            }
        },

        switchTab(tab) {
            this.activeTab = tab;
            if (!this.tabs[tab].loaded) {
                this.fetchPage(tab);
            }
        },

        fetchPage(type) {
            let tab = this.tabs[type];
            if (tab.loading || !tab.hasMore) return;

            tab.loading = true;
            let nextPage = tab.page + 1;

            fetch('/notifications/paginated?type=' + type + '&page=' + nextPage)
                .then(r => r.json())
                .then(data => {
                    tab.items = tab.items.concat(data.notifications || []);
                    tab.hasMore = data.has_more || false;
                    tab.page = data.current_page;
                    tab.loaded = true;
                    tab.loading = false;
                })
                .catch(err => {
                    console.error('Fetch notifications error:', err);
                    tab.loading = false;
                });
        },

        loadMore() {
            this.fetchPage(this.activeTab);
        },

        markAsRead(type, id) {
            let self = this;
            let url, item;

            if (type === 'user') {
                url = '/notifications/' + id + '/read';
                item = this.tabs.user.items.find(n => n.id === id);
            } else if (type === 'team') {
                url = '/team-info/' + id + '/read';
                item = this.tabs.team.items.find(n => n.id === id);
            } else {
                url = '/site-notifications/' + id + '/read';
                item = this.tabs.site.items.find(n => n.id === id);
            }

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success && item) {
                        item.read = true;
                        if (self.unreadCounts[type] > 0) self.unreadCounts[type]--;
                        self.dispatchCountUpdate();
                    }
                })
                .catch(err => console.error('Mark as read error:', err));
        },

        markAllAsRead(type) {
            let self = this;
            let url;

            if (type === 'user') url = '/notifications/read-all';
            else if (type === 'team') url = '/team-info/read-all';
            else url = '/site-notifications/read-all';

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.tabs[type].items.forEach(n => n.read = true);
                        self.unreadCounts[type] = 0;
                        self.dispatchCountUpdate();
                    }
                })
                .catch(err => console.error('Mark all as read error:', err));
        },

        dispatchCountUpdate() {
            window.dispatchEvent(new CustomEvent('notification-count-changed', {
                detail: {
                    user: this.unreadCounts.user,
                    team: this.unreadCounts.team,
                    site: this.unreadCounts.site
                }
            }));
        },

        getTypeIcon(type) {
            const icons = {
                'message': 'mail', 'match_request': 'sports_soccer', 'availability_request': 'schedule',
                'league_message': 'campaign', 'admin': 'admin_panel_settings', 'discipline': 'gavel',
                'infirmerie': 'local_hospital', 'formation': 'groups', 'transfert': 'swap_horiz',
                'match': 'sports_soccer', 'finance': 'payments', 'stade': 'stadium', 'scout': 'search',
                'suspension': 'block', 'injury': 'healing', 'budget': 'account_balance',
                'scout_suggestion': 'person_search', 'match_ready': 'sports_esports',
                'new_user': 'person_add', 'competition_join': 'group_add', 'new_task': 'task'
            };
            return icons[type] || 'notifications';
        },

        getTypeColor(type) {
            const colors = {
                'message': '#3b82f6', 'match_request': '#22c55e', 'availability_request': '#eab308',
                'league_message': '#ef4444', 'admin': '#a855f7', 'discipline': '#dc2626',
                'infirmerie': '#f97316', 'formation': '#22c55e', 'transfert': '#3b82f6',
                'match': '#6366f1', 'finance': '#10b981', 'stade': '#f59e0b', 'scout': '#06b6d4',
                'suspension': '#ef4444', 'injury': '#f59e0b', 'budget': '#3b82f6',
                'scout_suggestion': '#06b6d4', 'match_ready': '#22c55e',
                'new_user': '#3b82f6', 'competition_join': '#22c55e', 'new_task': '#a855f7'
            };
            return colors[type] || '#6b7280';
        },

        formatDate(dateString) {
            if (!dateString) return '';
            let date = new Date(dateString);
            let now = new Date();
            let diffMs = now - date;
            let diffMins = Math.floor(diffMs / 60000);
            let diffHours = Math.floor(diffMins / 60);
            let diffDays = Math.floor(diffHours / 24);

            if (diffMins < 1) return "À l'instant";
            if (diffMins < 60) return 'Il y a ' + diffMins + ' min';
            if (diffHours < 24) return 'Il y a ' + diffHours + 'h';
            if (diffDays < 7) return 'Il y a ' + diffDays + 'j';
            return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
        }
    };
};
